import { load } from 'recaptcha-v3'
import vv_fr from 'vee-validate/dist/locale/fr'
import { isLanguageFrench } from '@/helpers/Language.helpers'
import { config } from '@/config.settings'
import { setI18nLocale } from '@/I18n'

/**
 * This is a mixin used for recaptcha protection on the login-page
 * @public
 */
export default {
  data: function () {
    return {
      recaptca_enabled: true,
      loading: false,
    }
  },
  methods: {
    /**
     * Function that load recaptcha protection on the login-page
     */
    setRecaptcha: function () {
      if (!this.recaptca_enabled) {
        $('.grecaptcha-badge').hide()
        setTimeout(() => {
          $('.grecaptcha-badge').hide()
        }, 500)
        return
      }
      const _this = this
      void load(config.recaptcha_sitekey).then((recaptcha) => {
        recaptcha
          .execute('login')
          .then((token) => {
            _this.recaptcha_token = token
            $('.grecaptcha-badge').show()
          })
          .catch(() => {})
      })
    },
  },
  mounted() {
    $('body').addClass('login-page')
    if (isLanguageFrench()) {
      this.$language.current = 'fr_FR'
      setI18nLocale('fr')

      if (this.$validator) {
        this.$validator.localize('fr', vv_fr)
      }
      const html = document.documentElement
      html.setAttribute('lang', 'fr')
    } else {
      this.$language.current = 'en_US'
      setI18nLocale('en')

      if (this.$validator) {
        this.$validator.localize('en')
      }
      const html = document.documentElement
      html.setAttribute('lang', 'en')
    }
    if (!this.recaptca_enabled) {
      $('.grecaptcha-badge').hide()
      setTimeout(() => {
        $('.grecaptcha-badge').hide()
      }, 500)
    }
  },
  beforeRouteEnter(_to, _from, next) {
    next((vm) => {
      // access to component instance via `vm`
      vm.setRecaptcha()
      if (vm.step) {
        vm.step = 1
      }
    })
  },
}
